import { toast } from '@cyphex/ui';
import { desktopBridge } from '../bridge';
import { useDesktopEvent } from './useDesktopEvent';

const TOAST_ID = 'desktop-update';

/**
 * Surfaces the updater.
 *
 * A refused signature is the one update outcome that must NEVER be quiet: it
 * means somebody published a manifest this build cannot attribute to the
 * release key, and the only safe response is to stop and say so.
 */
export function useDesktopUpdates(): void {
  useDesktopEvent('update', (event) => {
    const status = event.status;

    if (status.phase === 'ready') {
      toast.success('An update is ready.', {
        id: TOAST_ID,
        duration: Infinity,
        description: status.version
          ? `Version ${status.version} will be applied when you restart.`
          : 'It will be applied when you restart.',
        action: {
          label: 'Restart now',
          onClick: () => {
            void desktopBridge()?.installUpdate();
          },
        },
      });
      return;
    }

    if (status.phase === 'error') {
      toast.error('Update refused.', {
        id: TOAST_ID,
        duration: 10_000,
        description: status.message ?? 'The update could not be verified.',
      });
      return;
    }

    /* checking / downloading / disabled are routine. Announcing them would
       train people to ignore the toast that actually matters. */
  });
}
